import { Navigate, useLocation } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import { ApplicationForm } from "../../components/ApplicationForm/ApplicationForm";
import { ApplicationFormContextProvider } from "../../components/ApplicationForm/ApplicationFrom.ctx";
import { isUserOrArchitect } from "../../hoc/isUserOrArchitect";
import {
  useBasicForm,
  useNameOfServiceField,
} from "../../hooks/applications.hooks";
import { cookieUtils } from "../../utils/cookieUtils";

export const AddApplication = isUserOrArchitect(() => {
  const { isFetching, isError, data } = useBasicForm();
  const location = useLocation();

  const serviceQuery = useNameOfServiceField();
  const nameOfService = location.state?.name_of_service;

  const registrationData =
    cookieUtils.getSecureCookie("userRegistrationDetails");
  const typeOfApplicationSubmitter =
    registrationData?.user_type ?? "";
  const userDetails = cookieUtils.getSecureCookie("userDetails");
  const typeOfApplicationSubmitterBy =
    userDetails?.name ?? "";

  console.log(
    "[AddApplication] userRegistrationDetails cookie:",
    registrationData
  );
  console.log(
    "[AddApplication] typeOfApplicationSubmitter derived:",
    typeOfApplicationSubmitter,
    typeOfApplicationSubmitterBy,
  );
  console.log(
    "[AddApplication] Passing defaultValues to ApplicationForm:",
    {
      name_of_service: nameOfService,
      typeOfApplicationSubmitter,
      typeOfApplicationSubmitterBy
    }
  );

  if (
    !nameOfService ||
    (serviceQuery.data?.options?.length &&
      !serviceQuery.data.options.some((e) => e?.id === nameOfService))
  ) {
    return <Navigate to="/user-applications" />;
  }

  let toRender = null;
  if (isFetching || isError || !data?.data) {
    toRender = (
      <div className="flex justify-center items-center p-8">
        {isError || (!isFetching && !data?.data) ? (
          <p>Something went wrong while fetching info!</p>
        ) : (
          <SpinnerCircular />
        )}
      </div>
    );
  } else if (data?.data) {
    toRender = (
      <ApplicationFormContextProvider>
        <ApplicationForm
          defaultValues={{ name_of_service: nameOfService, type_of_application_submitter: typeOfApplicationSubmitter, submitted_by: typeOfApplicationSubmitterBy }}
          defaultSteps={[data?.data]}
        />
      </ApplicationFormContextProvider>
    );
  }

  return toRender;
});
